import { Component, DestroyRef, EventEmitter, Injector, Input, OnInit, Output } from "@angular/core";
import { UserService } from "@main/users";
import { ControlBase } from ".";
import { EpisodeService } from "@project/episode/episode.service";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { OrganizationClinician } from "@main/users/organization-clinician";
import { UserHelperService } from "@main/users/user-helper.service";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { LinkUserService } from "@main/users";

@Component({
    selector: "m-select-clinician",
    template: `
        <p-dropdown
            *miproLoading="!controlInitialized; diameterPx: '30px'"
            [options]="clinicians"
            [showClear]="showClear"
            [tooltip]="tooltip"
            [tooltipPosition]="tooltipPosition"
            [(ngModel)]="selectedClinician"
            [ngModelOptions]="{ standalone: true }"
            [filter]="true"
            filterBy="fullName"
            appendTo="body"
            dataKey="id"
            [placeholder]="placeholder"
            (onBlur)="onTouched()"
            [styleClass]="klass">
            <ng-template pTemplate="item" let-option> {{ option.fullName }} ({{ option.role }}) </ng-template>
            <ng-template pTemplate="selectedItem"> {{ selectedClinician?.fullName }} ({{ selectedClinician?.role }}) </ng-template>
        </p-dropdown>
    `,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SelectClinicianControlComponent, multi: true }]
})
export class SelectClinicianControlComponent extends ControlBase<string> implements OnInit {
    private _selectedClinician: OrganizationClinician;
    private _preselectClinicianId: string;

    controlInitialized = false;
    clinicians: OrganizationClinician[] = [];

    @Input() showClear = true;
    @Input() placeholder = "Select Clinician";
    @Input() selectLoggedClinician = true;
    @Input() tooltip: string = "";
    @Input() tooltipPosition: "top" | "right" | "left" | "bottom" = "top";

    @Output() readonly onClinicianChange = new EventEmitter<OrganizationClinician>();

    get selectedClinician() {
        return this._selectedClinician;
    }
    set selectedClinician(clinician: OrganizationClinician) {
        this._selectedClinician = clinician;
        this.onChange(clinician?.id);
        this.onClinicianChange.emit(clinician);
    }

    constructor(
        private userService: UserService, 
        private episodeService: EpisodeService,
        private userHelperService: UserHelperService,
        private broadcastService: BroadcastService) {
        super();

        this.broadcastService
            .on(LinkUserService.UserSelectedOrganizationChangedEventName)
            .subscribe(async () => {
                this.clinicians = await this.userService.getCurrentOrganizationClinicians();
                this.clinicians.forEach(u => (u.role = this.episodeService.getRole(u.roles.join("#"))));
            });
    }

    async ngOnInit() {
        super.ngOnInit();

        this.clinicians = await this.userService.getCurrentOrganizationClinicians();
        this.clinicians.forEach(u => (u.role = this.episodeService.getRole(u.roles.join("#"))));

        let _currentClinicianId: string = null;
        if (this._preselectClinicianId) {
            _currentClinicianId = this._preselectClinicianId;
        } else if (this.selectLoggedClinician) {
            _currentClinicianId = this.userHelperService.userId;
        }

        this.selectClinician(_currentClinicianId);

        this.controlInitialized = true;
    }

    writeValue(obj: string): void {
        if (!this.controlInitialized) {
            this._preselectClinicianId = obj;
        } else {
            this.selectClinician(obj);
        }
    }

    private selectClinician(id: string) {
        this.selectedClinician = this.clinicians.find(c => c.id === id);
    }
}
